import React from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '../Footer';

// Pie de página global con los enlaces legales, para que estén accesibles desde
// cualquier página (art. 10 LSSI-CE: acceso "permanente, fácil y directo").
// Se omite donde ya hay pie propio (inicio), en login/registro (llevan los
// enlaces dentro del formulario y bloquean el scroll en móvil) y en las
// pantallas del concurso que se emiten en directo / OBS.
const rutaSinFooter = (pathname) => {
  if (['/', '/login', '/register'].includes(pathname)) return true;
  return pathname.startsWith('/quiz') && !pathname.startsWith('/quiz/formulario-');
};

const SiteFooter = ({ sidebarVisible }) => {
  const { pathname } = useLocation();
  if (rutaSinFooter(pathname)) return null;

  return (
    <div className={`transition-all duration-300 ${sidebarVisible ? 'lg:pl-56' : ''}`}>
      <Footer />
    </div>
  );
};

export default SiteFooter;
